// =============================================
// BRIDA Wishlist — localStorage (per customer)
// =============================================

function getWishlistKey() {
  var cid = window.__brida_customer_id;
  return cid ? 'brida_wishlist_' + cid : 'brida_wishlist';
}

function getWishlist() {
  try { return JSON.parse(localStorage.getItem(getWishlistKey())) || []; }
  catch(e) { return []; }
}

function saveWishlist(list) {
  localStorage.setItem(getWishlistKey(), JSON.stringify(list));
}

function isWishlisted(productId) {
  return getWishlist().some(function(item) { return String(item.id) === String(productId); });
}

function toggleWishlist(productId, productData) {
  var list = getWishlist();
  var idx = list.findIndex(function(item) { return String(item.id) === String(productId); });
  if (idx > -1) {
    list.splice(idx, 1);
  } else {
    list.push(Object.assign({ id: productId }, productData));
  }
  saveWishlist(list);
  return idx === -1;
}

function syncWishlistButtons() {
  document.querySelectorAll('.wfs-add-to-wishlist').forEach(function(btn) {
    var id = btn.dataset.productId;
    var path = btn.querySelector('path');
    if (isWishlisted(id)) {
      btn.classList.add('wishlisted');
      btn.setAttribute('aria-label', 'Remove from wishlist');
      if (path) path.setAttribute('fill', 'currentColor');
    } else {
      btn.classList.remove('wishlisted');
      btn.setAttribute('aria-label', 'Add to wishlist');
      if (path) path.setAttribute('fill', 'none');
    }
  });
  updateWishlistCount();
}

function updateWishlistCount() {
  var count = getWishlist().length;
  document.querySelectorAll('.wishlist-count-badge').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

// Global click event to add items across collection/product view panels
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.wfs-add-to-wishlist');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var productId = btn.dataset.productId;
  var productData = {
    handle:    btn.dataset.productHandle,
    title:     btn.dataset.productTitle,
    image:     btn.dataset.productImage,
    price:     btn.dataset.productPrice,
    url:       btn.dataset.productUrl,
    variantId: btn.dataset.variantId
  };

  var added = toggleWishlist(productId, productData);
  syncWishlistButtons();
  showToast(added ? '❤️ Added to Wishlist' : 'Removed from Wishlist');
  
  // Dynamic window execution loop in case page element is loaded
  if (typeof renderWishlistPage === 'function') {
    renderWishlistPage();
  }
});

function showToast(msg) {
  var toast = document.getElementById('brida-wishlist-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'brida-wishlist-toast';
    toast.style.cssText = [
      'position:fixed', 'bottom:24px', 'left:50%', 'transform:translateX(-50%)',
      'background:#111', 'color:#fff', 'padding:12px 24px', 'border-radius:30px',
      'font-size:14px', 'z-index:99999', 'opacity:0', 'transition:opacity 0.3s ease',
      'pointer-events:none', 'white-space:nowrap', 'box-shadow:0 4px 16px rgba(0,0,0,0.18)'
    ].join(';');
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.style.opacity = '1';
  clearTimeout(toast._timer);
  toast._timer = setTimeout(function() { toast.style.opacity = '0'; }, 2500);
}

// Document listener setup for handling badges early on global tree layers
document.addEventListener('DOMContentLoaded', function() {
  syncWishlistButtons();
});